import type { ValidationError } from "@tanstack/react-form";
import { useForm } from "@tanstack/react-form";
import { useNavigate } from "react-router-dom";

import { useForgotPassword } from "@/api/auth";
import { InsideLabelFieldInput } from "@/components/form";
import AuthPageTitle from "@/components/layout/auth-page-title";
import LoginReturnFooter from "@/components/layout/login-return-footer";
import {
  emailSchema,
  forgotPasswordDefaultValues,
  forgotPasswordSchema,
} from "@/schemas/auth";
import { stopPropagation } from "@/utils/form";

const ForgotPasswordPage = () => {
  const { mutateAsync } = useForgotPassword();
  const navigate = useNavigate();

  const { Field, Subscribe, handleSubmit } = useForm({
    defaultValues: forgotPasswordDefaultValues,
    validators: {
      onSubmit: ({ value }) => {
        const { email } = value;
        const returnValue: { fields: { [k: string]: ValidationError } } = {
          fields: {},
        };
        if (!emailSchema.safeParse(email).success) {
          const emailError: ValidationError = "Veuillez entrer un email valide";
          returnValue.fields["email"] = emailError;
        }
        return returnValue;
      },
    },
    onSubmit: async ({ value }) => {
      mutateAsync(value, {
        onSuccess: () => {
          navigate(`/mot-de-passe-oublie/email`, {
            state: { email: value.email },
          });
        },
      });
    },
  });

  return (
    <form
      onSubmit={(e) => stopPropagation(e, handleSubmit)}
      className="grid grid-flow-row grid-cols-1 gap-12 pr-[112px] pl-[112px] w-full"
    >
      <AuthPageTitle
        title="Mot de passe oublié ?"
        subTitle="Pas de souci, on vous envoie un lien de réinitialisation de votre mot de passe."
      />

      <InsideLabelFieldInput
        Field={Field}
        name="email"
        label="Email"
        schema={forgotPasswordSchema}
        autoComplete="email"
        validators={{ onChange: forgotPasswordSchema.shape.email }}
      />

      <LoginReturnFooter Subscribe={Subscribe} />
    </form>
  );
};

export default ForgotPasswordPage;
